import React, { useState } from 'react';

function DailyHistory({ dailyHistory }) {
  const [expanded, setExpanded] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: 'date', direction: 'ascending' });

  const sortedHistory = [...dailyHistory].sort((a, b) => {
    if (sortConfig.key) {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];
      if (aValue < bValue) {
        return sortConfig.direction === 'ascending' ? -1 : 1;
      }
      if (aValue > bValue) {
        return sortConfig.direction === 'ascending' ? 1 : -1;
      }
    }
    return 0;
  });

  const requestSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const getSortIndicator = (key) => {
    if (sortConfig.key === key) {
      return (
      <span>
        <span style={{ color: sortConfig.direction === 'ascending' ? 'black' : 'lightgray', fontSize: '0.8em' }}>▲</span>
        <br />
        <span style={{ color: sortConfig.direction === 'descending' ? 'black' : 'lightgray', fontSize: '0.8em' }}>▼</span>
      </span>
      );
    }
    return (
      <span>
        <span style={{ color: 'lightgray', fontSize: '0.6em' }}>▲</span>
        <br />
        <span style={{ color: 'lightgray', fontSize: '0.6em' }}>▼</span>
      </span>
    );
  };

  return (
    <div>
      <div style={{ textAlign: 'center' }}>
        <button onClick={() => setExpanded(!expanded)}>
          {expanded ? 'Collapse Raw Data' : 'See Raw Data'}
        </button>
      </div>
      {expanded && (
        <div>
          <table className="history-table">
            <thead>
              <tr>
                <th onClick={() => requestSort('date')}>{getSortIndicator('date')} Date</th>
                <th onClick={() => requestSort('open')}>{getSortIndicator('open')} Open</th>
                <th onClick={() => requestSort('high')}>{getSortIndicator('high')} High</th>
                <th onClick={() => requestSort('low')}>{getSortIndicator('low')} Low</th>
                <th onClick={() => requestSort('close')}>{getSortIndicator('close')} Close</th>
                <th onClick={() => requestSort('volume')}>{getSortIndicator('volume')} Volume</th>
              </tr>
            </thead>
            <tbody>
              {sortedHistory.map((history, index) => (
                <tr key={index}>
                  <td>{new Date(history.date).toLocaleDateString()}</td>
                  <td>${history.open.toFixed(2)}</td>
                  <td>${history.high.toFixed(2)}</td>
                  <td>${history.low.toFixed(2)}</td>
                  <td>${history.close.toFixed(2)}</td>
                  <td>{history.volume}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default DailyHistory;